import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  Dashboard
} from "../../_metronic/_partials";
import { ErrorPage1 } from "../modules/ErrorsExamples/ErrorPage1";

export function DashboardPage() {

  return (
    <>
      <Switch>
        <Route path={`/`} component={Dashboard} />
        <Route path={`/*`} component={ErrorPage1} />
      </Switch>
    </>
  );
}
